import { render, staticRenderFns } from "./ChooseChemicalsItem.vue?vue&type=template&id=00933b2d&scoped=true&"
import script from "./ChooseChemicalsItem.vue?vue&type=script&lang=js&"
export * from "./ChooseChemicalsItem.vue?vue&type=script&lang=js&"
import style0 from "./ChooseChemicalsItem.vue?vue&type=style&index=0&id=00933b2d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00933b2d",
  null
  
)

export default component.exports